import $ from 'jquery';
import 'slick-carousel';


$('.slider').each((i, elem) => {
    const $parent = $(elem);
    const $slider = $parent.find('.slider__slides');
    const $prevArrow = $parent.find('.slider__arrow-prev');
    const $nextArrow = $parent.find('.slider__arrow-next');

    $slider.on('beforeChange', (ev, slider) => {
        const $slide = slider.$slides.eq(slider.currentSlide);
        const $desc = $slide.closest('.slider').find('.slider__description');
        $desc.css('opacity', 0);
    });

    $slider.on('init afterChange', (ev, slider) => {
        const $slide = slider.$slides.eq(slider.currentSlide);
        const $item = $slide.find('[data-slider-description]');
        const description = ($item.attr('data-slider-description') || '').trim();
        const $desc = $slide.closest('.slider').find('.slider__description');
        $desc.text(description);
        if (description === '') {
            $desc.hide();
        } else {
            $desc.show();
        }
        $desc.css('opacity', 1);
    });

    $slider.slick({
        autoplay: false,
        autoplaySpeed: 7000,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: false,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        rows: 0,
        responsive: [{
            breakpoint: 992,
            settings: {
                draggable: true
            }
        }]
    });
});

